<div class="dialog">
  @if (theme !== MessageDialogTheme.Neutral) {
    <div>
      @switch (theme) {
        @case (MessageDialogTheme.Alert) {
          <img class="icon" alt="Alert" title="Alert" src="/assets/default/alert.svg">
        }
        @case (MessageDialogTheme.Danger) {
          <img class="icon" alt="Danger" title="Danger" src="/assets/default/alert.svg">
        }
        @case (MessageDialogTheme.Success) {
          <img class="icon" alt="Success" title="Success" src="/assets/default/input-approved.svg">
        }
      }
    </div>
  }
  @if (title) {
    <h3>{{ title }}</h3>
  }
  <div class="message">
    @for (paragraph of message; track paragraph) {
      <p>{{ paragraph }}</p>
    }
  </div>
  <div class="button-group button-group--center">
    @if (secondaryButton) {
      <button
        class="btn btn-secondary"
        (click)="pick(secondaryButton)"
        >
        {{ secondaryButton.label }}
      </button>
    }
    <button
      class="btn confirm"
      [class.btn-primary]="theme !== MessageDialogTheme.Danger"
      [class.btn-danger]="theme === MessageDialogTheme.Danger"
      (click)="pick(primaryButton)"
      >
      {{ primaryButton.label }}
    </button>
  </div>
</div>
